



























































































































































































































































import {API} from '@/services/api/api';
import {getImage, Utils} from '@/utils/Utils';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import Drift from 'drift-zoom';
import Constants from '@/utils/constants';
import {findDeckMarkerInDeckImg} from '@/utils/DeckOperations';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import lodash from 'lodash';
import canvasMerge from '@/utils/CanvasMerge';
import {debounce} from 'ts-debounce';
@Component({
  methods: {
    ...mapActions(['setCurrentTab', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {...mapGetters(['shipList'])},
})
export default class EditZone extends Vue {
  commonValidationMsg = 'This field is required';

  shipValidationMsg = '';
  deckValidationMsg = '';
  createdImage = null;

  loaderIndex = null;
  isScreenLoading = true;
  isScreenLoadingForImage = false;
  btnLoader = false;
  drift: any;
  shipList: any;
  originalZoneData: any = [];
  zoneData = [
    {
      zoneValidationMsg: '',
      remarkValidationMsg: '',
      endPointValidationMsg: '',
      zoneDeckId: null,
      zoneName: '',
      remarks: '',
      zoneStartPoint: null,
      zoneEndPoint: null,
      startPointValidationMsg: '',
      isActive: true,
      isLoading: false,
    },
  ];

  decks: any = [];
  deckImageURL = '';

  // zoneName = 'test-zone';
  // remarks = 'test-remark';
  // zoneStatus = true;
  drawingId: number = null;
  shipImageURL = '';
  focusedStartPoint = null;

  showSuccessToast: any;
  showErrorToast: any;
  setCurrentTab: any;
  shipId: number = null;

  zoneId: string = null;
  cropper = null;
  // find zones

  isAutomatedEnable = true;
  scandResult: any = null;
  // end find zones

  //toggle between manual and automatic mode
  onToggle() {
    this.isAutomatedEnable = !this.isAutomatedEnable;
    if (!this.isAutomatedEnable) {
      this.initCropper();
    } else {
      this.destroyCropper();
    }
  }

  //life cycle hook call on page mounted
  mounted() {
    this.zoneId = this.$route.params.id as string;
    console.log('zone id', this.zoneId);
    if (this.zoneId) {
      this.getZoneInfoById();
    }

    if (this.shipList.length > 0) {
      this.decks = this.shipList.drawings;
    }
    document.body.addEventListener('keydown', this.keyDownEvent);
  }

  //add event listener on key for moving crop box
  keyDownEvent(event) {
    let e = event || window.event;
    Utils.keyDownEvent(e, this.cropper);
  }

  destroyed() {
    document.body.removeEventListener('keydown', this.keyDownEvent);
  }

  // on deck load
  onDeckLoad() {
    this.initCropper();
    this.renderLine();
  }

  // load zoom in third image container
  onDeckLoad2() {
    this.initDriftZoom();
  }

  // initialize crop box on image
  initCropper() {
    const t = this.$refs.image as HTMLImageElement;
    const _this = this;

    this.cropper = new Cropper(t, {
      autoCrop: false,
      crop() {
        const data = this.cropper.getData(true);

        const index = _this.zoneData.length;

        if (_this.focusedStartPoint !== null) {
          _this.zoneData[_this.focusedStartPoint].zoneStartPoint = data.x;

          _this.zoneData[_this.focusedStartPoint].zoneEndPoint = data.x + data.width;

          _this.zoneData[_this.focusedStartPoint].endPointValidationMsg = '';
          _this.zoneData[_this.focusedStartPoint].startPointValidationMsg = '';
        }
        _this.$forceUpdate();
        _this.renderLine();
      },
      zoomable: false,
      viewMode: 2,
      data: {
        x: t.naturalWidth / 3,
        y: t.naturalHeight / 3,
        width: t.naturalWidth / 3,
        height: t.naturalHeight / 3,
      },
    });
  }
  //destroy crop box cropper
  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  //focus cursor on input box
  focusOnEndPoint(index) {
    this.focusedStartPoint = index;
  }

  //focus out cursor from input box
  blurOnEndPoint(index) {
    if (this.focusedStartPoint === index) {
      this.focusedStartPoint = null;
    }
  }

  //focus cursor on input box
  focusOnStartPoint(index) {
    this.focusedStartPoint = index;
  }

  //focus out cursor from input box
  blurOnStartPoint(index) {
    if (this.focusedStartPoint === index) {
      this.focusedStartPoint = null;
    }
  }

  _changeShip() {
    if (this.shipId === null || this.shipId.toString().length < 1) {
      this.shipValidationMsg = this.commonValidationMsg;

      return false;
    } else {
      this.deckImageURL = '';
      this.scandResult = null;

      this.loadDeckListInit();
      this.shipValidationMsg = '';
      this.drawingId = null;
      return true;
    }
  }

  _changeDeck() {
    if (this.drawingId === null || this.drawingId.toString().length < 1) {
      this.deckValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.deckValidationMsg = '';
      this.showDeckImage();
    }
  }
  validateShipSelect() {
    if (this.shipId === null || this.shipId.toString().length < 1) {
      this.shipValidationMsg = this.commonValidationMsg;

      return false;
    } else {
      this.shipValidationMsg = '';
      return true;
    }
  }

  validateDeckSelect() {
    if (this.drawingId === null || this.drawingId.toString().length < 1) {
      this.deckValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.deckValidationMsg = '';
      return true;
    }
  }

  validateZone() {
    let retrunVar = true;
    this.zoneData.map((obj, index) => {
      this.zoneData[index].zoneValidationMsg = this.zoneData[index].remarkValidationMsg = this.zoneData[
        index
      ].startPointValidationMsg = this.zoneData[index].endPointValidationMsg = '';
      if (obj.zoneName === '') {
        this.zoneData[index].zoneValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      }
      if (obj.remarks === '') {
        this.zoneData[index].remarkValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      }

      if (obj.zoneStartPoint === null || obj.zoneStartPoint === '') {
        this.zoneData[index].startPointValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      }
      if (obj.zoneEndPoint === null || obj.zoneEndPoint === '') {
        this.zoneData[index].endPointValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      } else if (Number(obj.zoneStartPoint) >= Number(obj.zoneEndPoint)) {
        this.zoneData[index].endPointValidationMsg = 'End point of zone must be greater than start point';

        retrunVar = false;
      }
    });
    this.$forceUpdate();
    this.renderLine();

    return retrunVar;
  }

  validateAll() {
    return this.validateShipSelect() && this.validateDeckSelect() && this.validateZone();
  }

  async getZoneInfoById() {
    try {
      const response = await API.fetchZoneInfoById(this.zoneId);

      if (response.data) {
        const data = response.data;

        this.shipId = data.drawing.ship.shipId;
        this.zoneData = data.zoneMasters;
        this.originalZoneData = data.zoneMasters;
        //

        //

        //

        this.drawingId = data.drawingId;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async loadDeckListInit() {
    // this.drawingId = null;

    try {
      this.isScreenLoading = true;

      const params = {
        alldecks: 1,
        withoutzones: 0,
        withoutcenter: 0,
      };
      const response = await API.fetchEmptyDecksByShipId(params, this.shipId);

      if (response.data) {
        const data = response.data;
        this.decks = data.drawings;

        this.showDeckImage();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: error});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async showDeckImage() {
    const index = this.decks.findIndex((obj: any) => obj.drawingId == this.drawingId);

    if (index !== -1) {
      try {
        this.createdImage = null;

        this.isScreenLoadingForImage = true;
        this.scandResult = Utils.parseJson(this.decks[index].scanResult);
        this.deckImageURL = await getImage(this.decks[index].imagePath);
        this.createdImage = null;
      } catch (error) {
        console.error(error);
        this.showErrorToast({msg: 'Network Error'});
      } finally {
        this.isScreenLoadingForImage = false;
      }
    }
  }

  async _updateHandler() {
    if (!this.validateAll()) return;

    try {
      this.btnLoader = true;

      const zoneMasters = this.zoneData.map((obj) => {
        return {
          zoneDeckId: obj.zoneDeckId,
          zoneName: obj.zoneName,
          remarks: obj.remarks,
          zoneStartPoint: obj.zoneStartPoint,
          zoneEndPoint: obj.zoneEndPoint,
          isActive: obj.isActive,
        };
      });

      const response = await API.updateZoneInfoById(this.zoneId, {
        drawingId: this.drawingId,
        zoneMasters,
      });

      if (response.data) {
        this.showSuccessToast({msg: response.message});

        this.$router.push('/');
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  addZone(length: number) {
    if (length === 0 || this.validateZone()) {
      this.zoneData.push({
        zoneValidationMsg: '',
        remarkValidationMsg: '',
        endPointValidationMsg: '',
        zoneName: '',
        remarks: '',
        zoneStartPoint: null,

        zoneEndPoint: null,
        startPointValidationMsg: '',
        isActive: false,
        zoneDeckId: null,
        isLoading: false,
      });
    }
  }

  //Delete zone from  APIs
  async deleteZone(zone) {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });
    const index = this.zoneData.findIndex((data) => data === zone);
    this.loaderIndex = index;

    try {
      if (zone.zoneDeckId === null || zone.zoneDeckId === undefined) {
        const index = this.zoneData.findIndex((data) => data === zone);
        this.zoneData.splice(index, 1);
        this.loaderIndex = null;
      } else {
        // this.isScreenLoading = true;
        const response = await API.deleteZoneById(zone.zoneDeckId);

        if (response.message) {
          // this.getZoneInfoById();
          const index = this.zoneData.findIndex((data) => data === zone);
          this.zoneData.splice(index, 1);
          this.loaderIndex = null;
          this.renderLine();
        } else {
          this.showErrorToast({msg: response.error});
        }
      }
    } catch (error) {
      // this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //initialize zoomed container on hover imag
  initDriftZoom() {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });
    this.isAutomatedEnable
      ? (this.drift = new Drift(this.$refs.image2, {
          paneContainer: document.getElementById('ppppp'),
          // inlinePane: 900,
          inlineOffsetY: -85,
          containInline: true,
          handleTouch: false,
          inlinePane: false,
          zoomFactor: 5,

          hoverBoundingBox: true,
        }))
      : null;
  }
  //disable zoomed container on hover image
  disableDriftZoom() {
    if (this.drift) {
      this.drift.destroy();
    }
  }

  changeTab() {
    this.$router.go(-1);
  }

  //Get zone from scaned image
  _findZones() {

    if (this.scandResult !== null) {
      const zones = this.scandResult.Zones;

      if (!zones) return;

      if (zones[0].Zone.ZoneNumber === 0 && zones[0].Zone.StartPoint.X === 0 && zones[0].Zone.EndPoint.X === 0) {
        this.showErrorToast({msg: 'Zone not found'});
      } else {
        var newzones = [...zones];
        const data = newzones.filter(
          (elem) => !this.originalZoneData.find((x) => elem.Zone.StartPoint.X === x.zoneStartPoint)
        );

        const newData = data.map((me) => {
          return {
            zoneValidationMsg: '',
            remarkValidationMsg: '',
            endPointValidationMsg: '',
            zoneDeckId: me.zoneDeckId,
            zoneName: '',
            remarks: '',
            zoneStartPoint: me.Zone.StartPoint.X,
            zoneEndPoint: me.Zone.EndPoint.X,
            startPointValidationMsg: '',
            isActive: true,
          };
        });
        const oldData = this.zoneData;
        this.zoneData.push.apply(oldData, newData);
      }
    }
  }

  @Watch('shipId', {immediate: true})
  fetchDecks() {
    if (this.shipId !== null) this.loadDeckListInit();
  }

  _reseImage() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }

  //Draw line on image
  draw() {
    const data = this.zoneData;
    let lines = [];
    if (data.length > 0 && this.deckImageURL) {
      const image = this.$refs.image2 as HTMLImageElement;

      data.forEach((ele) => {
        if (ele.zoneStartPoint) {
          lines.push({
            mx: ele.zoneStartPoint,
            my: 0,
            x: ele.zoneStartPoint,
            y: image.naturalHeight,
          });
          if (lines.length === data.length) {
            this.mergeImage(lines);
          }
        }
      });
    }
  }

  renderLine = debounce(() => this.draw(), 500);

  mergeImage(lines) {
    canvasMerge(this.deckImageURL, lines).then((b64) => {
      this.createdImage = b64;
      this.initDriftZoom();
    });
  }

  @Watch('zoneData', {immediate: true})
  zoneChange(change) {
    if (change.length > 0) {
      this.renderLine();
    }
  }
}
